import { render, staticRenderFns } from "./adddisciple.vue?vue&type=template&id=6d2f6f3d&"
import script from "./adddisciple.vue?vue&type=script&lang=js&"
export * from "./adddisciple.vue?vue&type=script&lang=js&"
import style0 from "./adddisciple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2f6f3d')) {
      api.createRecord('6d2f6f3d', component.options)
    } else {
      api.reload('6d2f6f3d', component.options)
    }
    module.hot.accept("./adddisciple.vue?vue&type=template&id=6d2f6f3d&", function () {
      api.rerender('6d2f6f3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/adddisciple.vue"
export default component.exports